import { useContext } from "react";
import ReportSection from "./ReportSection";
import { AgentAccessContext } from "../../context/AgentAccessContextProvider";

export default function ReportHeaderSection({ user, substituteUser, title, onExport, exportDisabled }) {
    const agentAccess = useContext(AgentAccessContext);
    const darkMode = document.documentElement.getAttribute('data-gdstheme') === 'dark';

    if (substituteUser) {
        title = title + "- Sales Leader"
    }

    return (
        <ReportSection title={title} pageTitle printable onExport={onExport} exportDisabled={exportDisabled}>
            <img className="logo" src={`images/geico_agency${darkMode ? '_white' : ''}.svg`} alt="GEICO For Your Agency" />
            <div className="agency-info">
                <div>
                    <b> Agency Name: </b> {agentAccess?.display.name} <br />
                    <b> Agency G-Code: </b> {agentAccess?.display.id} <br />
                </div>
                <div>
                    <b> Agent Name: </b> {user.firstName || user.lastName !== '' ? `${user.firstName} ${user.lastName}` : substituteUser.name} <br />
                    <b> Agent I-Code: </b> {user.agentId !== '' ? user.agentId : substituteUser.id} <br />
                </div>
            </div>
            <img className="gecko" src="images/gecko-corner.png" alt="Gecko" />
        </ReportSection>
    )
}